(() => {
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function findBestQtyInputNear(packInfo) {
    // 1) Aynı parent içinde ara (senin pack-info quantity ile aynı blokta)
    let container = packInfo.parentElement;
    if (container) {
      const inputs = container.querySelectorAll('input.quantity__input');
      const visible = Array.from(inputs).find(isVisible);
      if (visible) return visible;
      if (inputs[0]) return inputs[0];
    }

    // 2) Daha geniş alan: en yakın product-info / section içinde ara
    const scope =
      packInfo.closest('product-info') ||
      packInfo.closest('.product') ||
      packInfo.closest('.shopify-section') ||
      document;

    const scopeInputs = scope.querySelectorAll('input.quantity__input');
    const visible2 = Array.from(scopeInputs).find(isVisible);
    return visible2 || scopeInputs[0] || null;
  }

  function updateOne(packInfo, qty) {
    const packSize = parseInt(packInfo.dataset.packSize, 10) || 0;
    if (!packSize) return;

    const packCountEl = packInfo.querySelector('.dp-pack-count');
    const pieceCountEl = packInfo.querySelector('.dp-piece-count');
    if (!packCountEl || !pieceCountEl) return;

    packCountEl.textContent = qty;
    pieceCountEl.textContent = qty * packSize;
  }

  function initPackInfo(packInfo) {
    if (packInfo.dataset.dpInit === '1') return;
    packInfo.dataset.dpInit = '1';

    const input = findBestQtyInputNear(packInfo);
    if (!input) return;

    const updateFromThisInput = () => {
      const qty = parseInt(input.value, 10) || 1;
      updateOne(packInfo, qty);
    };

    // input değişince
    input.addEventListener('input', updateFromThisInput);
    input.addEventListener('change', updateFromThisInput);

    // +/- tıklanınca (bazı temalarda input event gecikiyor)
    const wrap = input.closest('quantity-input') || input.parentElement;
    if (wrap) {
      wrap.addEventListener('click', (e) => {
        const btn = e.target.closest('button[name="plus"],button[name="minus"]');
        if (!btn) return;
        setTimeout(updateFromThisInput, 0);
      });
    }

    updateFromThisInput();
  }

  function initAll(root = document) {
    root.querySelectorAll('.dp-pack-info').forEach(initPackInfo);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    // Shopify bazen DOM’u yeniden çiziyor (variant change, section reload)
    const mo = new MutationObserver(() => initAll());
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
